import Link from "next/link";
import { Heading } from "../common/typography/Heading";
import ClientCarousel, { CarouselItem } from "../common/ui/ClientCarousel";
import ContentWrapper from "../common/wrappers/contentWrapper";
import { getStateBySlug } from "@/services/locations/locations.service";

export interface CitiesInThisStateProps {
  featuredCities: {
    slug: string;
    city: string;
  }[];
  countrySlug?: string;
  noPadding?: boolean;
}

export const CitiesInThisState = async ({
  noPadding = false,
  ...props
}: CitiesInThisStateProps) => {
  const subArray = [];
  const itemsPerSubArray: number = 6;

  //move pointer 6 items at a time
  if (props.featuredCities.length) {
    for (let i = 0; i < props.featuredCities.length; i += itemsPerSubArray) {
      //slice from 0 to 6, then from 6 to 12
      const chunk = props.featuredCities.slice(i, i + itemsPerSubArray);
      subArray.push(chunk);
    }
  }

  if (!subArray.length) {
    return null;
  }

  return (
    <ContentWrapper
      fullWidth
      className={`!mt-sections-mobile sm:!mt-sections-desktop-120 !overflow-y-visible !overflow-visible  ${noPadding ? "py-0" : "py-10"}`}
    >
      {/* <header className="contentContainer lg:-mb-50px  mb-30px js-only"> */}
      <Heading
        size="h5"
        as="p"
        className="lg:-mb-50px mb-50px  contentContainer js-only"
      >
        Cities we serve in this state
      </Heading>
      {/* </header> */}
      <ClientCarousel divider cursorGrab={false}>
        {subArray.map((i, car_idx) => (
          <CarouselItem
            key={car_idx}
            edgeCase
            className={`${car_idx === subArray.length - 1 ? "!mr-0 !pr-0 max-cw:!pl-6 !pl-0 !max-w-fit" : " !pl-6 max-cw:!pl-0"}`}
          >
            <ul
              className={`flex flex-col h-full gap-y-5px items-start justify-start lg:min-w-[25vw] ${car_idx === subArray.length - 1 ? "!mr-0 !pr-0 lg:!min-w-fit !min-w-fit" : ""}`}
            >
              {i?.map((city, city_idx: number) => (
                <Link
                  key={city_idx}
                  href={`/${props.countrySlug ? props.countrySlug + "/" : ""}car-detailing/${city.slug}`}
                >
                  <p>{city.city}</p>
                </Link>
              ))}
            </ul>
          </CarouselItem>
        ))}
      </ClientCarousel>

      <noscript className="flex flex-col contentContainer ">
        <div>
          <Heading size="h5" as="p">
            Cities we serve in this state
          </Heading>
        </div>
        <div className="flex flex-row overflow-x-scroll mt-14">
          {subArray.map((i, car_idx) => (
            <CarouselItem
              key={car_idx}
              edgeCase
              className={`${car_idx === subArray.length - 1 ? "!mr-0 !pr-0 max-cw:!pl-6 !pl-0 !max-w-fit" : " !pl-6 max-cw:!pl-0"}`}
            >
              <ul
                className={`flex flex-col h-full gap-y-5px items-start justify-start lg:min-w-[25vw] ${car_idx === subArray.length - 1 ? "!mr-0 !pr-0 lg:!min-w-fit !min-w-fit" : ""}`}
              >
                {i?.map((city, city_idx: number) => (
                  <Link
                    key={city_idx}
                    href={`/${props.countrySlug ? props.countrySlug + "/" : ""}car-detailing/${city.slug}`}
                  >
                    <p>{city.city}</p>
                  </Link>
                ))}
              </ul>
            </CarouselItem>
          ))}
        </div>
      </noscript>
    </ContentWrapper>
  );
};
